import { useMemo } from 'react';
import { selectAttendees, selectVisitors } from "./meeting-room-booking-dialog.duck";
import { useSelector } from "react-redux";

export function HasAttendees(): boolean {
  const attendees = useSelector(selectAttendees);
  const visitors = useSelector(selectVisitors);

  const retVal = useMemo(() => {
    return visitors.length > 0 || attendees.length > 0;
  }, [visitors, attendees]);

  return retVal;
}
